import { supabase } from './supabaseService';
export type SupportGroup = {
  key: 'salvavidas' | 'caryosa'; group_id: string; agent_id: string; kb_ids: string[];
  requested_enabled: boolean; revision: number;
  project_id?: string | null; default_assignee_id?: string | null; escalation_enabled?: boolean;
};
export type SupportRouting = { action: 'routing'; key: SupportGroup['key']; revision: number; project_id: string | null; default_assignee_id: string | null; escalation_enabled: boolean };
export type SupportState = {
  projects?: { id: string; name: string; status: string }[];
  assignments?: { project_id: string; user_id: string; users: {id:string;name:string;is_active:boolean} | null }[];
  groups: SupportGroup[];
  status: { key: string; revision: number; connected: boolean; enabled: boolean; last_seen_at: string }[];
  events: { id: number; key: string; kind: string; created_at: string }[];
};
async function request(body?: SupportGroup | SupportRouting): Promise<SupportState> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw Error('Inicia sesión para acceder al control.');
  const result = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/whatsapp-support/admin`, {
    method: body ? 'POST' : 'GET', cache: 'no-store',
    headers: { Authorization: `Bearer ${session.access_token}`, apikey: import.meta.env.VITE_SUPABASE_ANON_KEY, 'Content-Type': 'application/json' },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  if (!result.ok) throw Error(result.status === 409 ? 'No se guardó: recarga y comprueba que los grupos, agentes y documentos sean distintos.' :
    result.status === 403 ? 'Acceso reservado al superadministrador.' : 'Control sin instalar o sin conexión.');
  return result.json();
}
export const whatsappSupportService = { load: () => request(), save: (group: SupportGroup) => request({ key:group.key,revision:group.revision,group_id:group.group_id,agent_id:group.agent_id,kb_ids:group.kb_ids,requested_enabled:group.requested_enabled }), saveRouting: (routing: SupportRouting) => request(routing) };
